export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-14.e30b4ee8.jpg";